// AI-CONTEXT: See docs/features/updates-log.md
// Zet een lijst updates onder een kopje per maand, zodat 70 regels te scannen zijn.

import { MAANDEN } from './formatUpdateDate'

/**
 * @typedef {object} UpdateMonth
 * @property {string} key - 'YYYY-MM', bruikbaar als React-key
 * @property {string} label - 'Augustus 2026'
 * @property {Array<object>} items - De updates in die maand
 */

/**
 * Groepeert op maand met behoud van de volgorde waarin de updates binnenkomen.
 * De aanroeper heeft al gesorteerd; hier wordt niet opnieuw gesorteerd, anders
 * zouden twee verschillende sorteringen naast elkaar bestaan.
 *
 * @param {Array<object>} updates - Gesorteerde updates
 * @returns {Array<UpdateMonth>} Maandgroepen in dezelfde volgorde
 */
const groupUpdatesByMonth = (updates) => {
    if (!Array.isArray(updates)) return []

    /** @type {Array<UpdateMonth>} */
    const groepen = []

    updates.forEach((update) => {
        const key = update.date.slice(0, 7)
        const laatste = groepen[groepen.length - 1]

        if (laatste && laatste.key === key) {
            laatste.items.push(update)
            return
        }

        const maandIndex = Number(key.slice(5, 7)) - 1
        const maand = MAANDEN[maandIndex]

        groepen.push({
            key,
            label: `${maand.charAt(0).toUpperCase()}${maand.slice(1)} ${key.slice(0, 4)}`,
            items: [update],
        })
    })

    return groepen
}

export default groupUpdatesByMonth
